import { Component, Input } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { NotificationStatusEnum } from 'shared/constants/notification-statuses';
import { ICellRendererParams } from '@ag-grid-community/core/dist/esm/es6/rendering/cellRenderers/iCellRenderer';

@Component({
    selector: 'app-notification-status-renderer',
    templateUrl: './notification-status-renderer.component.html',
    styleUrls: ['./notification-status-renderer.component.scss'],
    standalone: false,
})
export class NotificationStatusRendererComponent implements ICellRendererAngularComp {
    @Input() set parentFilterValue(value: string) {
        this._parentFilterValue = value ?? 'selectAll';
    }

    get parentFilterValue(): string {
        return this._parentFilterValue;
    }

    @Input() isFloatingFilterIcon?: boolean = false;
    public notificationStatusEnum = NotificationStatusEnum;
    private _parentFilterValue: string = '';

    agInit(params: ICellRendererParams & { isFloatingFilterIcon?: boolean }): void {
        this.isFloatingFilterIcon = Boolean(params.isFloatingFilterIcon);
        this.parentFilterValue = Object.values(NotificationStatusEnum)[Object.values(NotificationStatusEnum).indexOf(params.value)];
    }

    refresh() {
        return false;
    }
}
